import PortalIdParser from 'PortalIdParser';
export const getUserContactPageUrl = userId => {
  return `/contacts/${PortalIdParser.getPortalIdFromPath()}/contact/${userId}`;
};